import React from 'react';
import { GeneratorForm } from './GeneratorForm';
import { AnimatedHeroSVG } from './AnimatedHeroSVG';
import { CopyAnalysisResult } from '../types/copyAnalysis';

interface HeroProps {
  onAnalysisStart: () => void;
  onAnalysisComplete: (result: CopyAnalysisResult | null) => void;
}

export function Hero({ onAnalysisStart, onAnalysisComplete }: HeroProps) {
  return (
    <section className="pt-24 pb-16 px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-32 items-center">
        <div>
          <h1 className="text-3xl lg:text-5xl font-bold mb-6">
            Improve Your Website Copy in{' '}
            <span className="text-green-500">Just 11 Seconds</span>{' '}
            with AI-Powered Insights
          </h1>
          <p className="text-base lg:text-lg text-gray-600 mb-8 max-w-xl leading-relaxed">
            Uncover weak points in your content instantly. Use AI insights to create high-converting copy that dominates your competition.
          </p>
          <GeneratorForm 
            onAnalysisStart={onAnalysisStart} 
            onAnalysisComplete={onAnalysisComplete} 
          />
        </div>
        
        <div className="hidden lg:block">
          <AnimatedHeroSVG />
        </div>
      </div>
    </section>
  );
}